// Shared quota-meter helpers for the /usage page.
//
// `quotaPct(used, max)` returns a 0-100 integer percentage, clamped.
// `quotaColor(used, max)` returns a hex code suitable for AntD Progress
//   `strokeColor`. Mirrors the green/amber/red escalation used elsewhere
//   in the product (≤60% green, 60-90% amber, >90% red). When `max` is
//   zero or unknown we return grey so the bar shows but doesn't read as
//   "all used" — that case typically means the plan doesn't grant any
//   units of this resource (e.g. AI responses on an Essential plan).

export function quotaPct(used, max) {
  const u = Number(used) || 0;
  const m = Number(max) || 0;
  if (m <= 0) return 0;
  return Math.max(0, Math.min(100, Math.round((u / m) * 100)));
}

export function quotaColor(used, max) {
  const m = Number(max) || 0;
  if (m <= 0) return "#9ca3af"; // grey: plan grants zero of this resource
  const pct = quotaPct(used, max);
  if (pct >= 90) return "#f5222d"; // red
  if (pct >= 60) return "#faad14"; // amber
  return "#52c41a"; // green
}

// Friendly label for a quota row. Returns either "12 / 50 used" or,
// when max is zero, "Not included in your plan" so the bar's grey
// state has a clear textual explanation.
export function quotaLabel(used, max) {
  const m = Number(max) || 0;
  const u = Number(used) || 0;
  if (m <= 0) return "Not included in your plan";
  return `${u.toLocaleString("en-IN")} / ${m.toLocaleString("en-IN")} used`;
}
